import {registerSellingPlanSelector} from '@/components/buy-stack/flat-buy-stack/SellingPlanSelectorRegister';
import {registerGwpBuyStack} from '@/components/buy-stack/gwp-buy-stack/GwpBuyStackRegister';
import '@/components/buy-stack/gwp-buy-stack/GwpGiftModalRegister';
import '@/components/buy-stack/gwp-buy-stack/GwpImageCarouselRegister';
import {GwpVariant} from '@/components/buy-stack/gwp-buy-stack/types';
import {effect, signal} from '@preact/signals';

const selectedVariant = signal<GwpVariant | null>(null);
registerGwpBuyStack(selectedVariant);
registerSellingPlanSelector(selectedVariant);

effect(() => console.log('selectedVariant.value', selectedVariant.value));
